import React, { useEffect, useState } from 'react'

import { Outlet, useNavigate, useParams } from 'react-router-dom'

import useFirebase from 'hooks/firebase'

import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Checkbox,
  Chip,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import EditIcon from '@mui/icons-material/Edit'
import CreateDirector from 'widgets/director/create'

const SchoolDetails = (props) => {
  const params = useParams()
  const id = params.id

  const navigate = useNavigate()

  const { firestore } = useFirebase()
  const { 
    getSchool,
    getPreceptorsBySchoolId,
    getStudentsBySchoolId,
    preceptors,
    school,
    students,
    updateDocFromCollection
  } = firestore

  const [editingStages, setEditingStages] = useState(false)
  const [schoolStages, setSchoolStages] = useState([])
  const handleToggle = (stage) => () => {
    const currentIndex = schoolStages.indexOf(stage)
    const newStages = [...schoolStages]

    if (currentIndex === -1) {
      newStages.push(stage)
    } else {
      newStages.splice(currentIndex, 1)
    }

    setSchoolStages(newStages)
  }

  useEffect(() => {
    getSchool(id)
    getStudentsBySchoolId(id)
    getPreceptorsBySchoolId(id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  const stages = ['Kinder', 'Primaria', 'Secundaria', 'Preparatoria']
  useEffect(() => {
    if (school === undefined) return
    if (school.stages !== undefined) {
      const sortedStages = school.stages
      sortedStages.sort((a, b) => stages.indexOf(a) - stages.indexOf(b))
      setSchoolStages(sortedStages)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [school])

  const onSave = async () => {
    const data = {
      'stages': schoolStages
    }
    await updateDocFromCollection('schools', id, data)
    setEditingStages(false)
  }
  const onCancel = () => {
    setEditingStages(false)
    setSchoolStages(school.stages !== undefined ? school.stages : [])
  }

  const DashboardItem = (props) => {
    const { label, value } = props
    return (
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Typography color='primary' variant='body2'>
            <b>{label}</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography color='primary' variant='h6'>
            <b style={{ fontWeight: 900 }}>{value}</b>
          </Typography>
        </Grid>
      </Grid>
    )
  }
  
  // edecf3 bgcolor
  
  if (school === undefined) return <Outlet />
  return (
    <Grid container spacing={2} sx={{ p: 2 }}>
      <Grid item xs={12}>
        <Button onClick={() => navigate(-1)} size='large' startIcon={<ArrowBackIcon />}>
          <b>Volver</b>
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Typography color='primary' variant='h4'>
          <b style={{ fontWeight: 900 }}>{ school.name }</b>
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Card sx={{ borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={3}>
                <DashboardItem label='Director actual' value={school.director !== undefined ? school.director.name : 'Sin asignar'} />
              </Grid>
              <Grid item xs={12} md={3}>
                <DashboardItem label='Total de alumnos' value={students === undefined ? 0 : Object.keys(students).length} />
              </Grid>
              <Grid item xs={12} md={3}>
                <DashboardItem label='Total de preceptores' value={preceptors === undefined ? 0 : Object.keys(preceptors).length} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      {
        school.director === undefined ? (
          <Grid item xs={12} md={4}>
            <CreateDirector schoolId={id} />
          </Grid>
        ) : null
      }
      <Grid item xs={12} md={4}>
        <Card sx={{ borderRadius: 2, p: 2 }}>
          <CardContent sx={{ p: 0, '&:last-child': { paddingBottom: 0 } }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Grid container spacing={2} alignItems='center'>
                  <Grid item xs={8}>
                    <Typography color='primary' variant='body1'>
                      <b style={{ fontWeight: 900 }}>NIVELES ESCOLARES</b>
                    </Typography>
                  </Grid>
                  <Grid item xs={4} align='right'>
                    {
                      !editingStages ? (
                        <IconButton onClick={() => setEditingStages(true)} size='small'><EditIcon color='secondary' fontSize='small' /></IconButton>
                      ) : null
                    }
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                {
                  editingStages ? (
                    <List disablePadding>
                      {
                        stages.map((stage, index) => (
                          <ListItem key={`stage_${index}`} disablePadding>
                            <ListItemButton role={undefined} dense onClick={handleToggle(stage)}>
                              <ListItemIcon>
                                <Checkbox
                                  edge='start'
                                  checked={schoolStages.indexOf(stage) !== -1}
                                  tabIndex={-1}
                                  disableRipple
                                />
                              </ListItemIcon>
                              <ListItemText primary={stage} />
                            </ListItemButton>
                          </ListItem>
                        ))
                      }
                    </List>
                  ) : (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', }}>
                      {
                        schoolStages.map((stage, index) => (
                          <Box key={`chip_stage_${index}`} sx={{ px: 0 }}>
                            <Chip label={stage} color='secondary' variant='filled' sx={{ m: 0.5 }}/>
                          </Box>
                        ))
                      }
                    </Box>
                  )
                }
              </Grid>
            </Grid>
          </CardContent>
          {
            editingStages ? (
              <CardActions sx={{ justifyContent: 'end', p: 0, pt: 2 }}>
                <Button color='secondary' disableElevation variant='contained' onClick={onCancel}>
                  <b>Cancelar</b>
                </Button>
                <Button color='primary' disableElevation variant='contained' onClick={onSave}>
                  <b>Guardar</b>
                </Button>
              </CardActions>
            ) : null
          }
        </Card>
      </Grid>
    </Grid>
  )
}

export default SchoolDetails